import React from 'react';
import { Building2, Globe, Shield, AlertTriangle, UserCheck, Scale } from 'lucide-react';
import './Terminos.css';

const Terminos = () => {
  return (
    <div className="terminos-container">
      {/* Hero Section */}
      <section className="terminos-hero">
        <div className="terminos-hero-content">
          <h1 className="terminos-hero-title">Términos y Condiciones</h1>
          <p className="terminos-hero-subtitle">
            Condiciones generales de uso del sitio web de Meyle SRL
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="terminos-content-section">
        <div className="container">
          <div className="terminos-content">

            {/* 1. Identificación de la empresa */}
            <div className="terminos-block">
              <div className="terminos-block-header">
                <div className="terminos-block-icon">
                  <Building2 size={24} />
                </div>
                <h2 className="terminos-block-title">1. Identificación de la empresa</h2>
              </div>
              <div className="terminos-block-body">
                <ul className="terminos-datos-list">
                  <li><strong>Razón Social:</strong> MEYLE SRL</li>
                  <li><strong>CUIT:</strong> 30-70909268-1</li>
                  <li><strong>Domicilio Comercial:</strong> Agrelo 1381, Rosario Norte, Santa Fe, Argentina</li>
                  <li><strong>Email:</strong> <a href="mailto:meyle@meyle.com.ar">meyle@meyle.com.ar</a></li>
                  <li><strong>Teléfono:</strong> <a href="tel:+5493413047536">+54 9 341 304-7536</a></li>
                </ul>
              </div>
            </div>

            {/* 2. Objeto del sitio */}
            <div className="terminos-block">
              <div className="terminos-block-header">
                <div className="terminos-block-icon">
                  <Globe size={24} />
                </div>
                <h2 className="terminos-block-title">2. Objeto del sitio</h2>
              </div>
              <div className="terminos-block-body">
                <p>
                  El presente sitio web tiene carácter exclusivamente informativo. Meyle SRL actúa como
                  representante comercial en Argentina de las firmas <strong>TECNAL</strong> y <strong>KSB</strong>,
                  ofreciendo información sobre sus productos y soluciones industriales.
                </p>
                <p>
                  La información técnica publicada en este sitio es orientativa y no reemplaza la consulta
                  profesional. Para aplicaciones específicas, recomendamos contactar directamente a nuestro
                  equipo técnico.
                </p>
              </div>
            </div>

            {/* 3. Propiedad intelectual */}
            <div className="terminos-block">
              <div className="terminos-block-header">
                <div className="terminos-block-icon">
                  <Shield size={24} />
                </div>
                <h2 className="terminos-block-title">3. Propiedad intelectual</h2>
              </div>
              <div className="terminos-block-body">
                <p>
                  Todos los textos, imágenes, logotipos y demás contenidos publicados en este sitio son
                  propiedad de Meyle SRL o de sus representados (TECNAL, KSB), y se encuentran protegidos
                  por las leyes de propiedad intelectual vigentes.
                </p>
                <p>
                  Queda prohibida la reproducción total o parcial del contenido de este sitio sin la
                  autorización previa y por escrito de Meyle SRL.
                </p>
              </div>
            </div>

            {/* 4. Limitación de responsabilidad */}
            <div className="terminos-block">
              <div className="terminos-block-header">
                <div className="terminos-block-icon">
                  <AlertTriangle size={24} />
                </div>
                <h2 className="terminos-block-title">4. Limitación de responsabilidad</h2>
              </div>
              <div className="terminos-block-body">
                <p>
                  Las especificaciones técnicas de los productos y equipos presentados en este sitio pueden
                  variar sin previo aviso. Meyle SRL no se responsabiliza por decisiones tomadas en base a la
                  información publicada en este sitio sin la correspondiente verificación técnica.
                </p>
                <p>
                  Para aplicaciones específicas, se recomienda consultar con un técnico de Meyle a fin de
                  obtener información actualizada y adecuada a cada caso particular.
                </p>
              </div>
            </div>

            {/* 5. Datos personales */}
            <div className="terminos-block">
              <div className="terminos-block-header">
                <div className="terminos-block-icon">
                  <UserCheck size={24} />
                </div>
                <h2 className="terminos-block-title">5. Protección de datos personales</h2>
              </div>
              <div className="terminos-block-body">
                <p>
                  Los datos personales proporcionados a través de los formularios de contacto de este sitio
                  serán utilizados exclusivamente para responder las consultas realizadas por los usuarios.
                </p>
                <p>
                  Meyle SRL se compromete a no compartir dicha información con terceros y a cumplir con las
                  disposiciones de la <strong>Ley 25.326 de Protección de Datos Personales</strong> de la
                  República Argentina.
                </p>
              </div>
            </div>

            {/* 6. Ley aplicable */}
            <div className="terminos-block">
              <div className="terminos-block-header">
                <div className="terminos-block-icon">
                  <Scale size={24} />
                </div>
                <h2 className="terminos-block-title">6. Ley aplicable y jurisdicción</h2>
              </div>
              <div className="terminos-block-body">
                <p>
                  Los presentes Términos y Condiciones se rigen por la legislación vigente de la República
                  Argentina. Para cualquier controversia derivada del uso de este sitio, las partes se someten
                  a la jurisdicción de los Tribunales ordinarios de la ciudad de Rosario, provincia de Santa Fe.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Terminos;
